/* OWB LVL1 holster pattern configurator - 1836 Creations */
(function () {
  const root = document.querySelector('.owbp');
  if (!root) return;
  const $ = (id) => document.getElementById(id);
  const q = $('owbp-q'), sel = $('owbp-gun'), cantIn = $('owbp-cant'), prev = $('owbp-preview');
  const errEl = $('owbp-error'), statusEl = $('owbp-status'), form = $('owbp-form'), btn = $('owbp-cart');
  const DEFAULT_CANT = 8, DPI = 34;
  let guns = [], rt = null, ready = false;

  const showError = (m) => { errEl.textContent = m; errEl.hidden = !m; };
  const cantVal = () => {
    const v = parseFloat(cantIn.value);
    return isFinite(v) ? Math.min(20, Math.max(0, Math.round(v * 2) / 2)) : DEFAULT_CANT;
  };

  function fillList(term) {
    const keep = sel.value;
    const words = (term || '').toLowerCase().split(/\s+/).filter(Boolean);
    const list = guns.filter((g) => { const t = (g.mk + ' ' + g.md).toLowerCase(); return words.every((w) => t.includes(w)); });
    let html = '<option value="">Choose your handgun…</option>', mk = null;
    for (const g of list) {
      if (g.mk !== mk) { if (mk !== null) html += '</optgroup>'; html += `<option disabled></option><optgroup label="${esc(g.mk)}">`; mk = g.mk; }
      html += `<option value="${g.s}">${esc(g.md)}</option>`;
    }
    if (mk !== null) html += '</optgroup>';
    if (!list.length) html = '<option value="">No matches. Contact us for a custom pattern.</option>';
    sel.innerHTML = html;
    if (list.some((g) => g.s === keep)) sel.value = keep;
    else if (words.length && list.length === 1) { sel.value = list[0].s; render(); }
  }
  function esc(t) { return String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c])); }

  // Low-resolution, watermarked preview: drawn to a canvas, never shown as the full-scale vector pattern.
  function pageImage(svg, label) {
    return new Promise((resolve) => {
      const clean = svg.replace(/<path d="M5\.08,9\.73[^>]*\/><\/g><text[^>]*>3 INCHES<\/text>/, '</g>')
        .replace('<path fill="#231f20" fill-rule="evenodd" ', '<path ');
      const img = new Image();
      img.onload = () => {
        const W = Math.round(8.5 * DPI), H = Math.round(11 * DPI), c = document.createElement('canvas');
        c.width = W; c.height = H;
        const x = c.getContext('2d');
        x.filter = 'blur(0.6px)';
        x.drawImage(img, 0, 0, W, H);
        x.filter = 'none';
        x.save(); x.translate(W / 2, H / 2); x.rotate(-Math.PI / 5);
        x.fillStyle = 'rgba(139,90,43,0.22)'; x.font = `bold ${Math.round(DPI * 0.42)}px Helvetica, Arial, sans-serif`; x.textAlign = 'center';
        for (let r = -6; r <= 6; r++) for (let k = -2; k <= 2; k++) x.fillText('PREVIEW · 1836 CREATIONS', k * DPI * 6.2 + (r % 2) * DPI * 3.1, r * DPI * 1.1);
        x.restore();
        x.strokeStyle = 'rgba(139,90,43,0.18)'; x.lineWidth = 1;
        for (let i = -H; i < W + H; i += DPI * 0.75) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i - H, H); x.stroke(); }
        const out = new Image(); out.alt = label; out.src = c.toDataURL('image/jpeg', 0.7); out.draggable = false;
        resolve(out);
      };
      img.onerror = () => resolve(null);
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(clean);
    });
  }

  async function render() {
    showError('');
    const slug = sel.value, cant = cantVal();
    $('owbp-p-gun').value = ''; $('owbp-p-cant').value = ''; $('owbp-p-slug').value = '';
    btn.disabled = true;
    if (!slug) { prev.innerHTML = '<div class="owbp-empty">Choose your handgun to see the pattern</div>'; return; }
    statusEl.textContent = 'Building your pattern…';
    await new Promise((r) => setTimeout(r, 20));
    let res = null;
    try { res = window.OWB.render(slug, cant); } catch (e) { console.error(e); }
    if (!res) { statusEl.textContent = ''; showError('We could not build a pattern for this gun. Contact us and we will make it for you.'); return; }
    const imgs = await Promise.all(res.pages.map((p) => pageImage(p.svg, p.part)));
    prev.innerHTML = '';
    res.pages.forEach((p, i) => {
      const fig = document.createElement('figure'); fig.className = 'owbp-page';
      if (imgs[i]) fig.appendChild(imgs[i]);
      const cap = document.createElement('figcaption'); cap.textContent = p.part.toLowerCase() + (p.fits ? '' : ' (prints across 2 sheets)');
      fig.appendChild(cap); prev.appendChild(fig);
    });
    const g = guns.find((x) => x.s === slug);
    $('owbp-p-gun').value = g.mk + ' ' + g.md;
    $('owbp-p-cant').value = cant + '°';
    $('owbp-p-slug').value = slug;
    if (String(cant) !== cantIn.value) cantIn.value = cant;
    statusEl.textContent = 'Preview only. Your full-size, print-ready PDF (with build instructions) is emailed after purchase.';
    btn.disabled = false;
  }
  const renderSoon = () => { clearTimeout(rt); rt = setTimeout(render, 250); };

  prev.addEventListener('contextmenu', (e) => e.preventDefault());
  q.addEventListener('input', () => fillList(q.value));
  sel.addEventListener('change', render);
  cantIn.addEventListener('input', renderSoon);
  $('owbp-cant-reset').addEventListener('click', () => { cantIn.value = DEFAULT_CANT; render(); });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!$('owbp-p-slug').value) { showError('Choose your handgun first.'); return; }
    btn.disabled = true; btn.textContent = 'Adding…'; showError('');
    const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    try {
      const r = await fetch(base + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!r.ok) { const j = await r.json().catch(() => ({})); throw new Error(j.description || j.message || 'HTTP ' + r.status); }
      window.location.href = base + 'cart';
    } catch (err) {
      console.error(err);
      showError('Could not add to cart: ' + err.message + '. Please try again or contact us.');
      btn.disabled = false; btn.textContent = 'Add to cart';
    }
  });

  function start() {
    if (!window.OWB) return setTimeout(start, 50);
    guns = window.OWB.guns.slice().sort((a, b) => a.mk.localeCompare(b.mk) || a.md.localeCompare(b.md, undefined, { numeric: true }));
    fillList('');
    ready = true; statusEl.textContent = '';
  }
  start();
})();
